"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SYSceneNames {
}
SYSceneNames.Menu = "SYMenuScene";
SYSceneNames.Preload = "SYPreloadScene";
exports.default = SYSceneNames;
